const focusInput = function (e) {
    const input = e.target;
    const textArea = input.getElementsByTagName('textarea');
    const autoComplete = input.querySelector(ApexChat.options.elements.autoCompleteInput);
    if (textArea.length > 0) {
        textArea[0].focus();
    }
    if (autoComplete) {
        autoComplete.focus();
    }
};
export default focusInput;
